module.exports = __webpack_public_path__ + "ClientApp/content/tampa-st-petersburg.jpg";